module.exports = __webpack_public_path__ + "static/media/img_top_main1.6cb30ef0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_top_main1.webp
// module id = 771
// module chunks = 0